import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Card, Flex, Row, Space, Button } from "antd";
import { useState } from "react";

import { CardContainer } from "components/elements";
import DeductionTable from "components/table/DeductionTable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import styles from "../styles/Income.module.css";
import PayrollDeductionFilter from "./PayrollDeductionFilter";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

const PayrollDeduction = ({
  isLoading = false,
  pagination = {},
  incomeDeductionList = [],
  onCreate = () => { },
  onEdit = () => { },
  onDelete = () => { },
  onChange = () => { },
  onStatus = () => { },
  onSubmit = () => { },
  onCancel = () => { },

}) => {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);
  return (
    <Space className={styles.container} direction="vertical" size={24}>
      <Row justify="end">
        <Space direction="horizontal" size={24}>
          <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
            <Flex align="center" justify="center" gap={8}>
              <FilterIcon />
              <span style={{ color: "#667085" }}>{t('common.filter')}</span>
            </Flex>
          </Button>
          {
            roles.includes("CREATE_CONFIGURATION|PAYROLL_SETTING|DEDUCTION") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }}
              type="primary">
              <Flex align="center" justify="center" gap={8}>
                <CreateIcon />
                {t("common.create")}
              </Flex>
            </Button>
          }

        </Space>
      </Row>
      {useFilter && (
        <Card width="100%" style={{ border: "1px solid #EAECF0", borderRadius: "8px" }}>
          <PayrollDeductionFilter
            onChange={onChange}
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
          />
        </Card>
      )}
      {/* <CardContainer width="100%" height="fit-content"> */}
      <DeductionTable
        isLoading={isLoading}
        pagination={pagination}
        dataSource={incomeDeductionList}
        onEdit={onEdit}
        onDelete={onDelete}
        onChange={onChange}
        onStatus={onStatus}
      />
      {/* </CardContainer> */}
    </Space>
  );
};

export default PayrollDeduction;
